<div class="clearfix"></div>
    <div class="ui-g">
      <div class="ui-g-12">

        <h2>{{sectionTitle}}</h2>

        <div class="ui-g-12" style="color:#20417b;">
          <strong>{{this.items != null ? this.items.length.toString(): "0"}}</strong>&nbsp;{{'common.results' | translate}}
        </div>
        <hr style="display: block; height: 1px; border-top: 1px solid #dddddd;"/>
        <div class="ui-g-12">
          <div class="ui-g-4" style="vertical-align: bottom;padding-bottom: 10px; padding-top: 10px;">
            <div class="ui-g-5">
              <button *ngIf="allowsMultiSelection"
                      (click)="onSelectAll()"
                      [disabled]="this.items == null || this.items.length == 0"
                      class="rowButton"
                      style="height: 40px;"
                      pButton
                      type="button"
                      label="{{'common.select_all' | translate}}">
              </button>
            </div>
            <div class="ui-g-5">
              <button *ngIf="allowsMultiSelection"
                    (click)="onUnselectAll()"
                    [disabled]="this.items == null || this.items.length == 0"
                    class="rowButton"
                    style="height: 40px;"
                    pButton
                    type="button"
                    label="{{'common.unselect_all' | translate}}"></button>
            </div>
          </div>
          <div class="ui-g-2"></div>
          <div class="clear_fix"></div>


        </div>
        <div class="k-row">
            <div *ngFor="let button of customButtons" style="
          display:inline;
          text-align:right;
          padding-bottom: 10px;
          padding-top: 10px;">
            <button
              [disabled]="(selectedItemList.length == 0 && !button.isAlwaysEnabled)"
              type="button"
              pButton
              [CheckPermissions]="button.checkPerms"
              [class]="(button.class) ? button.class : 'k-generic-btn'"
              [label]="button.label"
              [icon]="button.icon"
              style="padding-right: 10px;"
              (click)="customButtonClick(button.callbackname)">
            </button>
          </div>
          <div class="clear_fix"></div>

        </div>
        <div class="k-row">

                <button *ngIf="addButton && permissionPOST" class="k-generic-btn" type="button" pButton icon="fa fa-plus" (click)="addItem()" [label]="addButton"
                style="text-align:right;padding-bottom: 10px; padding-top: 10px;display: inline;"></button>
              </div>

        <div class="clearfix"></div>
        <div [hidden]="!filterable" class="ui-widget-header" style="padding:4px 10px;border-bottom: 0 none;background-color: gray !important;">
          <i class="fa fa-2x fa-search" style="margin:4px 4px 0 0;color: #ffffff;"></i>
          <input #gb data-testid="gb" type="text" pInputText style="height:30px;width: 92%;font-size:15px;" placeholder="Global filter">
        </div>

        <p-dataTable
          [reorderableColumns]="true"
          [value]="items"
          [(selection)]="selectedItemList"
          [responsive]="true"
          [paginator]="true"
          [rows]="numRowsPerPage"
          [globalFilter]="gb"
          [editable]="editable"
          [groupField]="(groupedRowsBy) ? groupedRowsBy.id : null"
          [rowGroupMode]="(groupedRowsBy) ? 'subheader' : null"
          [expandableRowGroups]="(groupedRowsBy) ? 'true' : null"
          #dt
        >
          <ng-template
            pTemplate="rowgroupheader"
            *ngIf="groupedRowsBy"
            let-rowData
            let-rowIndex
          >{{rowData[groupedRowsBy.id]}}
          </ng-template>

          <p-column
            *ngIf="showSelectionCheckbox && this.items != null && this.items.length > 0"
            styleClass="col-button"
            [style]="{'width':'45px'}"
          >
            <ng-template let-item="rowData" let-i="rowIndex" pTemplate="body">
              <i *ngIf="item.checked" style="background-color: #fec65c; color: white;"  class="fa fa-fw fa-check kvCheckbox " (click)="this.onSelection(i, item)"></i>
              <i *ngIf="!item.checked" class="fa fa-fw kvCheckbox " (click)="this.onSelection(i, item)"></i>
            </ng-template>
          </p-column>

          <p-column
            *ngFor="let btn of customInlineButtons"
            styleClass="col-button"
            [style]="{'width':'45px'}"
          >
            <ng-template let-item="rowData" pTemplate="body">
              <button type="button" pButton [attr.matTooltip]="btn.tooltip"
                      (click)="this.onCustomInlineButton.emit({ callbackName: btn.callbackname, item: item });"
                      [icon]="btn.icon">
              </button>
            </ng-template>
          </p-column>

          <p-column

            *ngFor="let title of titles"
            [style]="{'text-align': (title.filterType == 'number' || title.filterType == 'numberHighlighted') ? 'right' : 'left'}"
            [field]="title.id"
            [header]="title.label | translate"
            [sortable]="!title.notSortable"
            [filter]="title.filterable || filterable"
            filterPlaceholder="Search"
            [editable]="title.editable"
            [styleClass]="getPatchClass(title)"
          >
            <ng-template *ngIf="title.filterType=='combo'" pTemplate="filter" let-col>
              <p-dropdown
                [options]="title.comboOptions"
                [style]="{'width':'100%'}"
                (onChange)="dt.filter($event.value,col.field,'equals')"
                styleClass="ui-column-filter"></p-dropdown>
            </ng-template>

            <ng-template let-col let-item="rowData" pTemplate="body" *ngIf="title.filterType == 'number'">
              {{item[col.field] | number: evaluateDecimals(title) }}
            </ng-template>
            <ng-template let-col let-item="rowData" pTemplate="body" *ngIf="title.filterType == 'numberHighlighted'">
              <div [ngStyle]="{'font-weight': 'bold', 'color': item[col.field] >= 0 ? 'green' : 'red'}" >{{item[col.field] | number:'1.1-1'}}</div>
            </ng-template>


            <ng-template let-col let-item="rowData" pTemplate="body" *ngIf="title.filterType=='date'">
              {{item[col.field] | date: this.srvCalTranslate.pcalendarTranslate.dateFormatFilter }}
            </ng-template>
            <ng-template *ngIf="title.filterType=='checkbox'" pTemplate="filter" let-col>

            </ng-template>
            <ng-template let-col let-item="rowData" pTemplate="body" *ngIf="title.filterType=='checkbox'">
              <input type="checkbox" class="dataTableCheckBox" disabled readonly checked="checked"
                     *ngIf="item[col.field]=='0'">
              <input type="checkbox" class="dataTableCheckBox" disabled readonly *ngIf="item[col.field]=='1'">
            </ng-template>


            <ng-template let-col let-item="rowData" pTemplate="editor" *ngIf="title.filterType=='date'">
              <p-calendar
                formControlName="item[col.field]"
                *ngIf="title.validator=={} && this.srvCalTranslate.pcalendarTranslate"
                [readonlyInput]="true"
                [dateFormat]="this.srvCalTranslate.pcalendarTranslate.dateFormat"
                [locale]="this.srvCalTranslate.pcalendarTranslate"
              ></p-calendar>
              <p-calendar
                *ngIf="title.validator.type=='date' && this.srvCalTranslate.pcalendarTranslate"
                [readonlyInput]="false"
                [dateFormat]="this.srvCalTranslate.pcalendarTranslate.dateFormat"
                [(ngModel)]="item[col.field]"
                [locale]="this.srvCalTranslate.pcalendarTranslate"
              ></p-calendar>
            </ng-template>
          </p-column>

          <p-column

            *ngIf="editable"
            styleClass="col-button"
            [style]="{'width':'45px'}"
          >
            <ng-template let-item="rowData" pTemplate="body">
              <button class="rowButton" type="button" pButton (click)="onEditInlineLocal(item);"
                      icon="fa fa-save"></button>
            </ng-template>
          </p-column>
          <p-column

            *ngIf="editButton"
            styleClass="col-button"
            [style]="{'width':'45px'}"
          >
            <ng-template let-item="rowData" pTemplate="body">
              <button *ngIf="permissionPUT" type="button" pButton (click)="this.selectedItem = item; this.editItem();"
                      icon="fa fa-pencil"
                      ></button>
            </ng-template>
          </p-column>
          <p-column
            *ngIf="deleteButton"
            styleClass="col-button"
            [style]="{'width':'45px'}"
          >
            <ng-template let-item="rowData" pTemplate="body">
              <button *ngIf="permissionDELETE" type="button" pButton (click)="this.selectedItem = item; this.deleteItem();"
                      icon="fa fa-trash"
                      ></button>
            </ng-template>
          </p-column>
        </p-dataTable>

        <p-dialog
          *ngIf="srvDataTable.get(id).showDetail"
          [width]="600"
          [height]="popupHeight"
          [(visible)]="srvDataTable.get(id).showDetail"
          [header]="detailSelected"
          [responsive]="true"
          showEffect="fade"
          [modal]="true"
          (onAfterHide)="onCancelDetail.emit();"
        >
          <ng-content></ng-content>
        </p-dialog>

      </div>
    </div>



// WEBPACK FOOTER //
// ./src/app/modules/UIKit/components/dataTable/dataTable.component.html